// extracted by mini-css-extract-plugin
export default {"container":"Terms_container__jb6uU","intro":"Terms_intro__8eHZT","block":"Terms_block__2k0T5","blockTitle":"Terms_blockTitle__D4ydh","bodyText":"Terms_bodyText__M0loa"};